// extracted by mini-css-extract-plugin
export default {"root":"IconWithMenu__root--q3Lst","icon":"IconWithMenu__icon--er_6D","menu":"IconWithMenu__menu--L53vf","nib":"IconWithMenu__nib--iwc8f"};